import ShelfController from '../../core/shelf.controller';
import { GPS_ACCURACY_THRESHOLD_M } from './elements/gps';

export const EMPTY_ROUTE_FILTERS = { channel: [], region: [], client: [] };

class RouteEfficiencyController extends ShelfController {
    async initialize() {
        if (!this.isAuthenticated) {
            this.navigateLogin();
            return;
        }

        try {
            const promotors = (await this.data.fetchUsersByUserType('promotor')) || [];
            this.setState({ promotors, loading: false });
        } catch (err) {
            this.props.onMessage?.('error', err?.response?.data?.message || err?.message || 'Error al cargar promotores');
            this.setState({ loading: false, error: true });
        }
    }

    retry() {
        this.setState({ loading: true, error: false }, () => this.initialize());
    }

    async loadRoute(userId, date) {
        if (!userId || !date) return;
        this.setState({ routeLoading: true, routeData: null });
        try {
            const response = await this.data.fetchPromoterRouteEfficiency(userId, date.format('YYYY-MM-DD'));
            this.setState({ routeData: response, routeLoading: false });
        } catch (err) {
            this.props.onMessage?.('error', err?.response?.data?.message || err?.message || 'Error al cargar ruta');
            this.setState({ routeLoading: false });
        }
    }

    selectPromotor(id) {
        this.setState({
            selectedPromotor: id || null,
            routeData: null,
            selectedVisitIndex: null,
            filters: EMPTY_ROUTE_FILTERS
        });
        if (id) this.loadRoute(id, this.state.selectedDate);
    }

    selectDate(d) {
        if (!d) return;
        this.setState({ selectedDate: d, filters: EMPTY_ROUTE_FILTERS });
        if (this.state.selectedPromotor) this.loadRoute(this.state.selectedPromotor, d);
    }

    selectVisit(index) {
        this.setState({ selectedVisitIndex: index });
    }

    setFilter(patch) {
        this.setState((prev) => ({ filters: { ...prev.filters, ...patch }, selectedVisitIndex: null }));
    }

    // Options for the canal/región/cliente selects, derived from the loaded route.
    visitFilterOptions(visits) {
        const distinct = (arr) =>
            [...new Set(arr.filter((v) => v !== undefined && v !== null && v !== ''))].sort((a, b) => String(a).localeCompare(String(b)));
        return {
            channel: distinct(visits.map((v) => v.channel)).map((v) => ({ value: v, label: v })),
            client: distinct(visits.map((v) => v.clientName)).map((v) => ({ value: v, label: v })),
            region: distinct(visits.flatMap((v) => (Array.isArray(v.regions) ? v.regions : []))).map((v) => ({
                value: v,
                label: v
            }))
        };
    }

    // Row-level filter; transit/summary stay relative to the real route order.
    applyVisitFilters(visits) {
        const { channel, region, client } = this.state.filters;
        const anyOf = (selected, value) => !selected?.length || selected.includes(value);
        return visits.filter((v) => {
            if (!anyOf(channel, v.channel)) return false;
            if (!anyOf(client, v.clientName)) return false;
            if (region?.length) {
                const regions = Array.isArray(v.regions) ? v.regions : [];
                if (!region.some((r) => regions.includes(r))) return false;
            }
            return true;
        });
    }

    // KPI summary for the (filtered) visits. Averages only count visits where the value was captured.
    summarizeVisits(visits) {
        const withDuration = visits.filter((v) => v.durationMinutes != null);
        const withTransit = visits.filter((v) => v.transitMinutes != null);
        const gpsIssues = visits.filter((v) => v.distanceMeters != null && v.distanceMeters > GPS_ACCURACY_THRESHOLD_M).length;

        const avgDuration =
            withDuration.length > 0 ? Math.round(withDuration.reduce((s, v) => s + v.durationMinutes, 0) / withDuration.length) : 0;
        const avgTransit =
            withTransit.length > 0 ? Math.round(withTransit.reduce((s, v) => s + v.transitMinutes, 0) / withTransit.length) : 0;

        return {
            visits: visits.length,
            avgDuration,
            avgTransit,
            gpsIssues,
            withDuration: withDuration.length,
            withTransit: withTransit.length
        };
    }
}

export default RouteEfficiencyController;
